import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store/index'
import i18n from './plugins/i18n'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    primary: '#546e7a',
    secondary: '#00897b',
    accent: '#546e7a',
    error: '#e5242b',
    info: '#1565C0',
    success: '#0a893b',
    warning: '#f9a825',
    awards_rated_5: '#e5242b',
    awards_rated_6: '#f9a825',
    awards_rated_7: '#f9a825',
    awards_rated_8: '#1565C0',
    awards_rated_9: '#0a893b',
    awards_rated_10: '#0a893b'
  }
})

Vue.use(VueI18n)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
